import { useContext } from "react";
import { TranslationContext } from "../helpers/Context";

const useTranslation = () => {
  const { translatedTexts } = useContext(TranslationContext);

  const T = (text) => {
    if (!translatedTexts || typeof translatedTexts !== 'object') {
      return text;
    }
    return translatedTexts[text] || text;
  };

  return T;
};

export default useTranslation;
